// removed by extract-text-webpack-plugin
module.exports = {"container":"LoadingSpinner__container__3o5IZ","progress":"LoadingSpinner__progress__1HxYm","icon":"LoadingSpinner__icon__1csbz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/LoadingSpinner/LoadingSpinner.css
// module id = 488
// module chunks = 0